module.exports = __webpack_public_path__ + "static/young-leader-photo-shaun_jackson-c4803951e9d974bb3c3e3b722fa11784.jpg";